import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { segmentTrackAction, SegmentUserEvent } from '../../../../../../../middlewares/segment';
import {
    COPIED_SNACKBAR_TEXT,
    SNACKBAR_ID_AFFILIATE_LINK_COPIED
} from '../../../../affiliate/hocs/AffiliateDialogHOC/constants';
import { snackbarSuccessDefault } from '../../../../../snackbarsStack';

export const onCopy = (
    link: string
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(window.location.origin + '/dashboard/google-spreadsheet-permission').then(() => {
                dispatch(snackbarSuccessDefault({
                    id: SNACKBAR_ID_AFFILIATE_LINK_COPIED,
                    text: COPIED_SNACKBAR_TEXT,
                    icon: 'link',
                }));
                dispatch(segmentTrackAction(SegmentUserEvent.AFFILIATE_LINK_COPIED));
            });
        }
    };
    return action;
};
